import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import {
  AddRounded as AddIcon,
  LocalShippingOutlined as TruckIcon,
  BuildOutlined as WrenchIcon,
  ArchiveOutlined as RetiredIcon,
  FolderOpenOutlined as FileIcon,
  ViewListOutlined as AllIcon,
} from '@mui/icons-material';
import { NavPanel, PanelButton, PanelGroup, PanelLink } from '../../components/layout/NavPanel';

// The Fleet section's side panel. One component for the list and for a
// truck's own page, so opening a truck does not swap the menu out from
// under you — the filters, their counts and "Add vehicle" stay put.

export type FleetFilter = 'active' | 'maintenance' | 'retired' | 'all';
export const FLEET_FILTERS: FleetFilter[] = ['all', 'active', 'maintenance', 'retired'];

export interface FleetCounts { active: number; maintenance: number; retired: number; all: number }

const FleetPanel: React.FC<{
  counts: FleetCounts;
  /** Which filter is lit; on a truck's page, the group that truck is in. */
  filter: FleetFilter | null;
  onFilter: (filter: FleetFilter) => void;
  onAdd: () => void;
}> = ({ counts, filter, onFilter, onAdd }) => {
  const { pathname } = useLocation();
  return (
    <NavPanel>
      {/* At the TOP of the panel, like Users and Hiring. */}
      <Button
        fullWidth
        variant="contained"
        disableElevation
        startIcon={<AddIcon />}
        onClick={onAdd}
        sx={{ mb: 2.5, py: 1 }}
      >
        Add vehicle
      </Button>

      {/* Same shape as Users: everything first, then the same list cut by
          status. */}
      <PanelGroup label="Vehicles">
        <PanelButton
          label="All vehicles" icon={<AllIcon />} count={counts.all}
          active={filter === 'all'} onClick={() => onFilter('all')}
        />
      </PanelGroup>

      <PanelGroup label="By status">
        <PanelButton
          label="On the road" icon={<TruckIcon />} count={counts.active}
          active={filter === 'active'} onClick={() => onFilter('active')}
        />
        <PanelButton
          label="In maintenance" icon={<WrenchIcon />} count={counts.maintenance}
          active={filter === 'maintenance'} onClick={() => onFilter('maintenance')}
        />
        <PanelButton
          label="Retired" icon={<RetiredIcon />} count={counts.retired}
          active={filter === 'retired'} onClick={() => onFilter('retired')}
        />
      </PanelGroup>

      <PanelGroup label="Paperwork">
        <PanelLink
          to="/files/roster/vehicle" label="Compliance by truck" icon={<FileIcon />} currentPath={pathname}
        />
      </PanelGroup>
    </NavPanel>
  );
};

export default FleetPanel;
